import { states, ObjType } from './utils/statesArray';

type GetStateObjectTypes = {
  state: string;
  version?: string;
};

type UseStateMachineTypes = {
  getStateObject: (props: GetStateObjectTypes) => ObjType | undefined;
};

function useStateMachine(): UseStateMachineTypes {
  const getStateObject = (props: GetStateObjectTypes): ObjType | undefined => {
    const { state, version } = props;

    const next = version
      ? states.find((o) => o.state === state && o.version === version)
      : states.find((o) => o.state === state);

    return next;
  };

  return {
    getStateObject,
  };
}

export default useStateMachine;
